import { Box, Typography } from "@mui/material";
import React from "react";
import { INK } from "../../theme/tokens";
import type { CommandCenterNurse, FloatingNursesRecData } from "../../utils/models";
import { DepartmentChips } from "../DepartmentChips/DepartmentChips";
import { FloatingNursesList } from "../FloatingNursesList/FloatingNursesList";

interface IProps {
	isActive: boolean;
	nurses: CommandCenterNurse[];
	stats: Record<string, number>;
	department: string;
	onSubmit: (data: FloatingNursesRecData) => void;
	onDiscard: (nurse: CommandCenterNurse) => void;
	handleSelectDepartment: (deparmentId: string) => void;
}

const FloatingNursesTabsContent = React.memo(({ onSubmit, onDiscard, nurses, handleSelectDepartment, department, stats, isActive }: IProps) => {
	return (
		<Box sx={{ position: "relative", height: "100%", overflow: "hidden" }}>
			<Box
				sx={{
					width: "100%",
					height: "100%",
					position: "relative",
					top: 0,
					left: 0,
					right: 0,
					display: isActive ? "inherit" : "none",
					transition: "opacity 0.15s ease-in-out",
					overflow: "auto",
				}}
			>
				<>
					<Box
						sx={{
							p: 0,
							m: 0,
							display: "flex",
							alignItems: "center",
							width: "100%",
						}}
					>
						<DepartmentChips stats={stats} handleSelectDepartment={handleSelectDepartment} selectedDepartment={department} />
					</Box>
					<Box
						sx={{
							px: 0,
							py: 0,
							pt: 2,
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							width: "100%",
						}}
					>
						<Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
							<Typography sx={{ fontSize: "14px", fontWeight: 600, color: INK.SECONDARY }}>Total ({nurses.length})</Typography>
						</Box>
					</Box>
					<Box sx={{ px: 0, py: 0, position: "relative", top: -10 }}>
						<FloatingNursesList onSubmit={onSubmit} onDiscard={onDiscard} nurses={nurses} isActive={isActive} />
					</Box>
				</>
			</Box>
		</Box>
	);
});

export default FloatingNursesTabsContent;
